import script from "./NoRecruitment.functional.vue?vue&type=script&setup=true&lang=js"
export * from "./NoRecruitment.functional.vue?vue&type=script&setup=true&lang=js"

import "./NoRecruitment.functional.vue?vue&type=style&index=0&id=26f8e3c0&lang=scss"

const __exports__ = script;

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
